module.exports = __webpack_public_path__ + "2fd03648313fa68849128809ab0ff748.svg";